import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";

/** Edit own fullName (theme is edited separately in the topbar). */
export function EditProfileDialog({ children }: { children?: React.ReactNode }) {
  const { profile, updateProfileName } = useAuth();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(profile?.fullName ?? "");
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    try {
      await updateProfileName(name);
      setOpen(false);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children ?? <Button variant="ghost">Edit profile</Button>}</DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit profile</DialogTitle>
          <DialogDescription>Update your display name.</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
          className="space-y-3"
        >
          <div>
            <Label htmlFor="ep-name">Full name</Label>
            <Input id="ep-name" value={name} onChange={(e) => setName(e.target.value)} autoFocus />
          </div>
          <Button type="submit" disabled={busy || !name.trim()} className="w-full">
            {busy ? "Saving…" : "Save"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
